import React from 'react';
import './Industries.css';
import { 
  FaLaptopCode, 
  FaCloud, 
  FaBitcoin, 
  FaHeartbeat, 
  FaShoppingCart, 
  FaCog,
  FaBalanceScale,
  FaTruck,
  FaStore,
  FaBullhorn,
  FaHome,
  FaHardHat,
  FaCoins,
  FaGem,
  FaEllipsisH,
  FaGraduationCap,
  FaPlane,
  FaFilm
} from 'react-icons/fa';

const Industries = () => {
  const industries = [
    { icon: <FaLaptopCode />, name: 'Tech' },
    { icon: <FaCloud />, name: 'SaaS' },
    { icon: <FaBitcoin />, name: 'FinTech' },
    { icon: <FaHeartbeat />, name: 'Healthcare' },
    { icon: <FaShoppingCart />, name: 'FMCG' },
    { icon: <FaCog />, name: 'Engineering' },
    { icon: <FaBalanceScale />, name: 'Legal' },
    { icon: <FaTruck />, name: 'Logistics' },
    { icon: <FaStore />, name: 'Retail' },
    { icon: <FaBullhorn />, name: 'Marketing' },
    { icon: <FaHome />, name: 'Real Estate' },
    { icon: <FaHardHat />, name: 'Construction' },
    { icon: <FaCoins />, name: 'Finance' },
    { icon: <FaGem />, name: 'Mining' },
    { icon: <FaGraduationCap />, name: 'Education' },
    { icon: <FaPlane />, name: 'Travel & Tourism' },
    { icon: <FaFilm />, name: 'Media & Entertainment' },
    { icon: <FaEllipsisH />, name: 'And More' }
  ];

  return (
    <section className="industries section" id="industries">
      <div className="container">
        <h2 className="section-title">Industries We Serve</h2>
        <p className="section-subtitle">
          Leveraging specialized insights across a diverse range of sectors.
        </p>
        
        <div className="industries-grid">
          {industries.map((industry, index) => (
            <div className="industry-card" key={index}>
              <div className="industry-icon">{industry.icon}</div>
              <h3 className="industry-name">{industry.name}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;